import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { Maintenance } from '@interfaces';
import { DialogEditMaintenanceComponent } from '../../../../dialog-maintenances.component';

@Component({
  selector: 'app-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss']
})
export class InfoBannerComponent {
  public isVisible = true;
  @Input() public maintenance: Maintenance;

  public constructor(
    private readonly matDialog: MatDialog,
    private readonly maintenancesApi: MaintenancesApi
  ) { }

  public hideBanner(): void {
    this.isVisible = false;
  }

  public async openPreviousMaintenance(): Promise<void> {
    const maintenance = await this.maintenancesApi.searchOne(this.maintenance.id).toPromise();

    this.matDialog.open(DialogEditMaintenanceComponent, {
      panelClass: 'dialog-edit-maintenance',
      data: {
        maintenance: maintenance,
        isViewMode: false,
        selectedTabIndex: 0,
      }
    });
  }
}
